import { shortcutGroups360 } from "../shortcuts/shortcutGroups";
import { editor360Tours } from "../tours/editor360Tours";
import type { OnboardingStrategy } from "../onboardingTypes";

/**
 * 360 onboarding content.
 *
 * Mirrors the TrainingSliceStrategy360 / 3D seam: nothing outside these
 * shortcutGroups are filled in by later PRs.
 */
export const OnboardingStrategy360: OnboardingStrategy = {
  tours: editor360Tours,
  hints: [],
  shortcutGroups: shortcutGroups360,
};
